// ---- Configuration générale de l'app -------
// ---- Flags d'activation / désactivation de fonctionnalités ------
// ---- Valeurs fixes de fonctionnalités ------

const APP_CONFIG = {
  DATATABLE_LAZY_LOADING_COUNT: 50,
  AUTOREDIRECT_TO_LOGIN: true,
  PER_PAGE_OPTIONS: ['10', '25', '50'], // en string pour chargement simplifie direct dans le select
  HOME_ROUTE: '/alertes',

  FETCH_TIMEOUT: 90000,  // timeout forcé d'un fetch, en milliseconds
  IMPORT_EXPORT_TIMEOUT: 300000,  // 5*60*1000 = 5 min
  API_URL: process.env.REACT_APP_API_URL, // URL de l'api, définie dans les .env
  API_KEY: process.env.REACT_APP_API_TOKEN, // x-api-key, défini dans les .env

  ENDPOINT_SUFFIX: process.env.REACT_APP_API_ENDPOINT_SUFFIX, // suffix en cas d'utilisation d'un mock

  SAML_ENABLED: process.env.REACT_APP_SAML_ENABLED ?? 'true',
  LOCALSTORAGE_PREFIX: process.env.REACT_APP_LOCALSTORAGE_PREFIX ?? 'osacplanif-',
  LOCALSTORAGE_ACTIVE: process.env.REACT_APP_LOCALSTORAGE_ACTIVE ?? 'true',

  SKILLS_ENABLED: process.env.REACT_APP_SKILLS_ENABLED ?? 'false',
};
export default APP_CONFIG;
